<script setup>
import {onMounted, reactive} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {ToastUtil} from "@/Utils/ToastUtil";
import {Permissions} from "@/Utils/Permissions";

onMounted(() => {
  getData();
});

const data = reactive({
  search: null,
  dataLoading: true,
  newAdj: false,
  headers: [
    { title: 'Claim Number', key: 'claimnumber' },
    { title: 'Insured', key: 'insuredname' },
    { title: 'Client', key: 'clientname' }
  ],
  items: [],
});

const getData = () => {
  ApiWrapper.get('claims','open-no-task')
      .then((response) => {
        data.items = response.claims;
        data.dataLoading = false;
      })
      .catch((error) => {
        ToastUtil.error(error);
        data.dataLoading = false;
      });
};

const GetIsFireType = (claim) => {
  if(claim.claimtype) {
    return claim.claimtype.toString().toLowerCase().includes('fire')
  }
  return false;
};

</script>

<template>
  <v-container id="aan-resize-target" fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>All Claims With No Task</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-row>
        <v-col cols="4">
          <v-text-field
              v-model="data.search"
              append-inner-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              class="ml-4"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-data-table
          :items="data.items"
          :headers="data.headers"
          item-value="claimid"
          :search="data.search"
          :loading="data.dataLoading"
          loading-text="Loading... Please wait"
      >
        <template v-slot:[`item.claimnumber`]="{ item }">
          <RouterLink :to="`/claim/${item.id}`">
            {{ item.claimnumber }}
          </RouterLink>
          <span class="ma-ml-3" v-if="GetIsFireType(item)"> <v-icon color="orange">mdi-fire-circle</v-icon> </span>
        </template>

        <template v-slot:[`item.clientname`]="{ item }">
          <RouterLink :to="`/client/${item.clientid}`" v-if="Permissions.checkPermissions(['clients.read'])">
            {{ item.clientname }}
          </RouterLink>
          <span v-else>{{ item.clientname }}</span>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>